import { Component, OnInit } from '@angular/core';
import { PhotoModel } from '../../models/photo.model';
import { AdsService } from '../../services/ads.service';
import { ConfigService } from '../../shared/utils/config.service';
import { RouterOutlet } from '@angular/router';
import { NgForOf } from '@angular/common';

@Component({
    imports:[RouterOutlet,NgForOf],
    standalone:true,
    providers:[
        AdsService,
        ConfigService
    ],
    selector: 'account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.css']
})

export class AccountComponent implements OnInit{
    photosR: PhotoModel[];
    photosL: PhotoModel[];
    photoUrl: string;

    constructor(private adsService: AdsService,
        private configService: ConfigService) {

        this.photosR = new Array<PhotoModel>();
        this.photosL = new Array<PhotoModel>();
        this.photoUrl = configService.getPhotoURL();
    }

    ngOnInit(): void {
        this.loadPhotos();
    }

    loadPhotos(): any {
        // this.adsService.getPhotosType(1).subscribe(p => {

        //     this.photosR = p;
        // });

        // this.adsService.getPhotosType(2).subscribe(p => {
        //     this.photosL = p;
        // });
    }

    imgClick(event: any) {
        let pId = event.target.id;

        var p = this.photosR.concat(this.photosL);

        var i = p.findIndex(a => a.id == pId);

        let url: any = '';

        url = url.match(/^https?:/) ? url : '//' + url;

        if (p[i].adLink.length > 1) {
            window.open(url + p[i].adLink);
        }
    }

}
